import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UtilityService } from './shared/utility.service';
import { delayedRetryHttp } from './shared/delayedRetry';
import { TxtMsgUserKeyword, TxtMsgUserKeywordLoadRespone, TxtMsgUserKeywordResponse } from '../models/user-keyword.model'
import { SimpleResponse } from '../models/genericResponse.model';
@Injectable({
  providedIn: 'root'
})
export class UserKeywordService {

    private baseUrl: string;
    private api: string = "api/UserKeyword";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    async setup(encryptedUser: string, kwid: number, uid: number, clpuserId: number, clpCompanyId: number): Promise<TxtMsgUserKeywordLoadRespone | void> {
        const a = await this.httpClient
            .get<TxtMsgUserKeywordLoadRespone>(`${this.baseUrl}/Setup?kwid=${kwid}&uid=${uid}&clpuserId=${clpuserId}&clpCompanyId=${clpCompanyId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "kwid - " + kwid + " , " + "uid - " + uid, encryptedUser, "UserKeywordService", "setup"); }); //toPromise();
        return a;
    }

    async txtMsgUserKeyword_GetList(encryptedUser: string, clpCompanyId: number, strKeyword: string, cLPUserID: number = 0, teamCode: number = 0): Promise<TxtMsgUserKeywordResponse | void> {
        const a = await this.httpClient
            .get<TxtMsgUserKeywordResponse>(`${this.baseUrl}/TxtMsgUserKeyword_GetList/${clpCompanyId}?strKeyword=${strKeyword}&cLPUserID=${cLPUserID}&teamCode=${teamCode}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "strKeyword - " + strKeyword + " , " + "cLPUserID - " + cLPUserID, encryptedUser, "UserKeywordService", "txtMsgUserKeyword_GetList"); }); //toPromise();
        return a;
    }

    async txtMsgUserKeyword_Delete(encryptedUser: string, txtMsgUserKeywordId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/TxtMsgUserKeyword_Delete/${txtMsgUserKeywordId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "txtMsgUserKeywordId - " + txtMsgUserKeywordId, encryptedUser, "UserKeywordService", "txtMsgUserKeyword_GetList"); }); //toPromise();
        return a;
    }

    async txtMsgUserKeyword_Load(encryptedUser: string, txtMsgUserKeywordId: number, cLPCompanyID: number): Promise<TxtMsgUserKeyword | void> {
        const a = await this.httpClient
            .get<TxtMsgUserKeyword>(`${this.baseUrl}/TxtMsgUserKeyword_Load/${txtMsgUserKeywordId}/${cLPCompanyID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "txtMsgUserKeywordId - " + txtMsgUserKeywordId, encryptedUser, "UserKeywordService", "txtMsgUserKeyword_Load"); }); //toPromise();
        return a;
    }

    async txtMsgUserKeyword_Update(encryptedUser: string, txtMsgUserKeyword: TxtMsgUserKeyword): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/TxtMsgUserKeyword_Update`, txtMsgUserKeyword,{
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "UserKeywordService", "txtMsgUserKeyword_Update"); }); //toPromise();
        return a;
    }

    async txtMsgUserKeyword_ConfirmDelete(encryptedUser: string, txtMsgUserKeywordId : number, cLPCompanyID : number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/TxtMsgUserKeyword_ConfirmDelete/${txtMsgUserKeywordId}/${cLPCompanyID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "UserKeywordService", "txtMsgUserKeyword_Update"); }); //toPromise();
        return a;
    }
}
